import { SECTION_NESTED_SIDEBAR_VIEWS } from '../../lib/sectionNavViews';

export const HELP_SECTION_NESTED_LABELS = SECTION_NESTED_SIDEBAR_VIEWS.map((view) => view.label);

/** Те же каналы, что mobile `Feedback.js`. Telegram — временный live-канал. */
export const HELP_SUPPORT_EMAIL = 'ag@sportsground.ru';
export const HELP_SUPPORT_MAILTO = `mailto:${HELP_SUPPORT_EMAIL}?subject=${encodeURIComponent('Площадка. Обратная связь.')}`;
export const HELP_SUPPORT_TELEGRAM_URL = 'https://t.me/encodedcookie';
export const HELP_SUPPORT_TELEGRAM_LABEL = '@encodedcookie';

export const HELP_ARTICLES = [
  {
    id: 'start',
    title: 'Как начать: центр и площадка',
    summary: 'Создайте спортивный центр и площадку. В каталоге приложения клуб появится после статуса «Одобрен».',
    href: '/centers',
    hrefLabel: 'Спортивные центры',
    illustration: 'start',
    steps: [
      {
        text: 'В сайдбаре откройте «Спортивные центры» и нажмите «Новый спортцентр».',
        href: '/new-center',
        hrefLabel: 'Новый спортцентр',
      },
      {
        text: 'Заполните «Название», «Город» и «Адрес», затем «Создать».',
      },
      {
        text: 'В списке появится статус «На проверке». Пока администратор не поставит «Одобрен», карточка не видна спортсменам в приложении.',
      },
      {
        text: 'Дальше «Площадки» → «Новая площадка»: зал, корт или бассейн внутри этого центра.',
        href: '/playgrounds',
        hrefLabel: 'Площадки',
      },
    ],
  },
  {
    id: 'hours',
    title: 'Режим работы и сетка расписания',
    summary: 'Сетка аренды и секций строится из режима работы площадки. Без слотов календарь пустой.',
    href: '/playgrounds',
    hrefLabel: 'Площадки',
    illustration: 'hours',
    steps: [
      {
        text: 'Откройте площадку. На карточке блок «Режим работы»: колонки «Будни» и «Выходные».',
      },
      {
        text: 'Часы без цены недоступны. Для секций без аренды укажите цену «0» — календарь появится.',
      },
      {
        text: 'Вкладка «Расписание» на площадке — единая сетка: аренда, блокировки, занятия секций.',
      },
      {
        text: 'Если календарь пустой, кнопка «Настроить режим работы площадки» ведёт обратно на карточку. Тот же текст есть в «Секции» → «Расписание».',
        href: '/sections/schedule',
        hrefLabel: 'Секции → Расписание',
      },
    ],
  },
  {
    id: 'bookings',
    title: 'Бронирования аренды',
    summary: 'Входящие брони площадки — в «Бронирования». Создать слот можно на вкладке «Расписание».',
    href: '/bookings',
    hrefLabel: 'Бронирования',
    illustration: 'bookings',
    steps: [
      {
        text: 'В сайдбаре раскройте «Площадки» и откройте вложенный пункт «Бронирования» — список аренды залов.',
        href: '/bookings',
        hrefLabel: 'Бронирования',
      },
      {
        text: 'Новую бронь ставят на вкладке «Расписание» площадки: свободный слот в сетке.',
      },
      {
        text: 'Аренда площадки — не абонемент секции и не «Доп. услуги и прокат». Это разные разделы.',
      },
    ],
  },
  {
    id: 'sections',
    title: 'Секции: группы и занятия',
    summary: 'Секция — программа тренировок. Группы дают слоты; без группы клиент не видит занятия в приложении.',
    href: '/sections',
    hrefLabel: 'Секции',
    illustration: 'sections',
    steps: [
      {
        text: '«Секции» → «Добавить секцию». Диалог называется «Новая секция». Тренер выбирается из «Сотрудники».',
        href: '/sections',
        hrefLabel: 'Секции',
      },
      {
        text: 'В карточке секции добавьте группу. Подсказка в интерфейсе: «Групп пока нет — добавьте первую, чтобы клиенты видели слоты в приложении.»',
      },
      {
        text: 'Под «Секции» в меню: «Расписание», «Абонементы», «Заявки», «Персональные».',
      },
      {
        text: '«Расписание» секций — «Единое расписание площадки (зала)»: аренда и занятия на одной шкале. Кнопки «Открыть на всю страницу» и «Настроить режим работы».',
        href: '/sections/schedule',
        hrefLabel: 'Расписание',
      },
    ],
  },
  {
    id: 'clients',
    title: 'Клиенты, заявки и абонементы',
    summary: 'Справочник организации — «Клиенты». Запись в секцию идёт через заявку и абонемент.',
    href: '/sections/clients',
    hrefLabel: 'Клиенты',
    illustration: 'clients',
    steps: [
      {
        text: '«Клиенты» — справочник организации по всем клубам сети, не вкладка одной секции.',
        href: '/sections/clients',
        hrefLabel: 'Клиенты',
      },
      {
        text: 'Входящие заявки — «Секции» → «Заявки». Если есть неодобренная заявка, сначала «Одобрить и оформить»: абонемент без одобрения не даст записаться в приложении.',
        href: '/sections/requests',
        hrefLabel: 'Заявки',
      },
      {
        text: 'Тарифы и выдача — «Абонементы». С карточки клиента можно «Выдать абонемент».',
        href: '/sections/abonements',
        hrefLabel: 'Абонементы',
      },
      {
        text: '«Персональные» — отдельные занятия, не групповой слот секции.',
        href: '/sections/personal',
        hrefLabel: 'Персональные',
      },
    ],
  },
];

export function getHelpArticle(articleId) {
  if (!articleId) return null;
  return HELP_ARTICLES.find((article) => article.id === articleId) || null;
}
